import { useState, useEffect, useCallback, useRef } from "react"

import Grid from '@material-ui/core/Grid'
import AddIcon from '@material-ui/icons/AddOutlined'
import CircularProgress from '@material-ui/core/CircularProgress'
import ModeEditIcon from '@material-ui/icons/EditOutlined'
import DialogRemove from '@base/Dialog/DialogRemove'
import ButtonPrimary from '@base/Button'
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import {
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils'

import EmpresaService from '@services/EmpresaService'
import EmpresaDialog from '@pages/Empresas/EmpresaDialog'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';

export const ListagemEmpresasPageView = () => {
  const [loading, setLoading] = useState(true);

  const [idEmpresa, setIdEmpresa] = useState();

  const [openDialogAdicionarEmpresa, setOpenDialogAdicionarEmpresa] = useState(false);
  const [openDialogRemove, setOpenDialogRemove] = useState(false);

  const [list, setList] = useState([]);

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const [defaultOrderBy,] = useState('nome')
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

  const toastRef = useRef(null);

  const pageName = 'Gerenciar Empresas';

  const actions = [
    {
      name: () => "Editar",
      func: (id) => { setIdEmpresa(id); setOpenDialogAdicionarEmpresa(true); },
      icon: (c, l) => <ModeEditIcon />,
      disabled: () => false,
    },
    {
      name: () => "Remover",
      func: (id) => { setOpenDialogRemove(true); setIdEmpresa(id); },
      icon: (c, l) => <DeleteOutlinedIcon />,
      color: () => "secondary",
      disabled: () => false,
    }
  ];

  const carregarDados = useCallback(() => {

    setLoading(true);

    let parametrosApi = [
      { field: 'page', value: page },
      { field: 'size', value: size }
    ];

    sort.forEach(s => {
      parametrosApi.push({ field: 'sort', value: `${s.orderBy},${s.order}` });
    });

    EmpresaService.listAll(parametrosApi).then(resultado => {
      const { content, number, size: newSize, totalElements, totalPages } = resultado.data;
      setList(content);
      setPage(number);
      setSize(newSize);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);
    }).catch(error => toastRef.current?.show("error", "Ocorreu um Problema ao Realizar Filtros!"));
  }, [page, size, sort]);

  const handlePage = page => { setPage(page); };
  const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); };
  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === orderBy)) {
      let newSort = sort.filter(s => s.orderBy !== orderBy);
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }]);
    }
  }
  const handleClearSort = (orderBy) => { orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: ASC }]) };
  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  const submitExcluir = (id, setLoading) => {
    EmpresaService.excluir(id)
      .then(resultado => {
        toastRef.current.show("success", "Empresa removida com sucesso!");
        carregarDados();
        setIdEmpresa(undefined);
      })
      .catch((error) => {
        if (error.response.data.mensagens !== undefined) {
          toastRef.current?.show("error", error.response.data.mensagens.map(mensagen => mensagen).join(" ,"));
        } else {
          toastRef.current?.show("error", "Ocorreu um erro ao excluir a empresa.");
        }
      })
      .finally(() => { setLoading(false); setOpenDialogRemove(false); });
  };

  useEffect(() => carregarDados(), [carregarDados]);

  const columns = [
    { label: 'id', name: 'id', func: (coluna, linha) => coluna, key: true },
    { label: 'Nome', name: 'nome', func: (coluna, linha) => coluna, key: false },
  ];

  return (
    <>
      <Toast ref={toastRef} />
      <Title>{pageName}</Title>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading} />

      <Grid container spacing={3} >
        <Grid item xs={12} >
          <ButtonPrimary
            onClick={() => { setIdEmpresa(undefined); setOpenDialogAdicionarEmpresa(true); }}
            name="Cadastrar Empresa"
            startIcon={loading ? <CircularProgress size={16} /> : <AddIcon />}
            disabled={loading}
          />
        </Grid>
      </Grid>

      {openDialogAdicionarEmpresa &&
        <EmpresaDialog
          id={idEmpresa}
          aberto={openDialogAdicionarEmpresa}
          loading={loading}
          toastRef={toastRef}
          handleLoading={setLoading}
          aoFechar={() => {
            setIdEmpresa(undefined);
            setOpenDialogAdicionarEmpresa(false)
          }}
          aoSalvar={(mensagem) => {
            setIdEmpresa(undefined);
            setOpenDialogAdicionarEmpresa(false);
            carregarDados();
            toastRef.current.show("success", mensagem);
          }}
        />
      }

      {openDialogRemove &&
        <DialogRemove
          maxWidth={"sm"}
          id={idEmpresa}
          text={"Tem certeza que seja excluir esta empresa?"}
          close={() => setOpenDialogRemove(false)}
          open={openDialogRemove}
          title={"Importante"}
          handleConfirm={submitExcluir}
        />
      }
    </>
  );
}

export default ListagemEmpresasPageView;
